<template>
  <div>
    <connections-switch-view active="chart" />
    <div
      v-if="chartData"
      class="connection-cards"
    >
      <div
        v-for="(item, index) in chartData"
        :key="index"
        class="card-item"
      >
        <div class="job-name">
          {{ item.jobName }}
          <div v-if="!item.finishedAt" class="job-status worked" />
          <div v-else class="job-status not-worked" />
        </div>
        <connection-chart
          :chart-data="clone(item.chart_data)"
          :options="chartOptions"
          class="chart-container"
        />
        <div
          v-if="item.startedAt"
          class="started-at"
        >
          Время начала: {{ formattedDate(item.startedAt.date) }}
        </div>
        <div
          v-if="item.finishedAt"
          class="finished-at"
        >
          Время окончания: {{ formattedDate(item.finishedAt.date) }}
        </div>
        <div
          v-if="item.lastMessageAt"
          class="last-message-at"
        >
          Время последнего сообщения: {{ formattedDate(item.lastMessageAt.date) }}
        </div>
        <div class="buttons">
          <div />
          <div>
            <v-btn
              type="submit"
              color="success"
              text
              small
              @click="details(item)"
            >
              Детали
            </v-btn>
            <v-btn
              type="submit"
              color="primary"
              text
              small
              @click="events(item.id)"
            >
              События
            </v-btn>
          </div>
        </div>
      </div>
    </div>
    <v-dialog v-model="dialog" max-width="600" scrollable>
      <v-card>
        <v-card-title>
          Детали соединения
        </v-card-title>

        <v-card-text>
          <div><b>ID</b></div>
          <div>{{ dialogData.id || '&mdash;' }}</div>
          <br>
          <div><b>ID краулера</b></div>
          <div>{{ dialogData.jobId || '&mdash;' }}</div>
          <br>
          <div><b>Название краулера</b></div>
          <div>{{ dialogData.jobName || '&mdash;' }}</div>
          <br>
          <div><b>Время начала</b></div>
          <div>{{ dialogData.startedAt || '&mdash;' }}</div>
          <br>
          <div><b>Время окончания</b></div>
          <div>{{ dialogData.finishedAt || '&mdash;' }}</div>
          <br>
          <div><b>Последнее время сообщения</b></div>
          <div>{{ dialogData.lastMessageAt || '&mdash;' }}</div>
          <br>
          <div><b>Ошибки</b></div>
          <div>{{ dialogData.errorMessagesCounter || '&mdash;' }}</div>
          <br>
          <div><b>Последнее время ошибки</b></div>
          <div>{{ dialogData.lastErrorMessageAt || '&mdash;' }}</div>
          <br>
          <div><b>Успешно</b></div>
          <div>{{ dialogData.successMessagesCounter || '&mdash;' }}</div>
          <br>
          <div><b>Последнее время успеха</b></div>
          <div>{{ dialogData.lastSuccessMessageAt || '&mdash;' }}</div>
          <br>
          <div><b>Параметры работы краулера</b></div>
          <div>
            <pre v-if="dialogData.settings">{{ dialogData.settings }}</pre>
            <template v-else>
              &mdash;
            </template>
          </div>
        </v-card-text>

        <v-card-actions>
          <div class="flex-grow-1" />
          <v-btn color="error" text @click="dialog = false">Закрыть</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import moment from 'moment';
import cloneDeep from 'lodash/cloneDeep';
import ConnectionChart from './components/ConnectionChart.vue';
import ConnectionsSwitchView from './components/ConnectionsSwitchView.vue';

export default {
  name: 'import-kafka-monitor',
  asyncData({ store }) {
    return store.dispatch('kafkaImportMonitor/getChartData');
  },
  components: {
    ConnectionsSwitchView,
    ConnectionChart,
  },
  data: () => ({
    dialog: false,
    dialogData: false,
    chartOptions: {
      responsive: true,
      maintainAspectRatio: false,
      legend: {
        display: true,
      },
      scales: {
        xAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0.05)',
          },
        }],
        yAxes: [{
          gridLines: {
            color: 'rgba(0, 0, 0, 0.05)',
          },
        }],
      },
    },
  }),
  computed: {
    ...mapState('kafkaImportMonitor', ['chartData']),
    formattedDate() {
      return x => moment(x).format('DD.MM.YYYY HH:mm');
    },
    clone() {
      return v => cloneDeep(v);
    },
  },
  methods: {
    details(item) {
      this.dialogData = { ...item };
      if (this.dialogData.startedAt) {
        this.dialogData.startedAt = this.formattedDate(
          this.dialogData.startedAt.date,
        );
      }
      if (this.dialogData.finishedAt) {
        this.dialogData.finishedAt = this.formattedDate(
          this.dialogData.finishedAt.date,
        );
      }
      if (this.dialogData.lastMessageAt) {
        this.dialogData.lastMessageAt = this.formattedDate(
          this.dialogData.lastMessageAt.date,
        );
      }
      if (this.dialogData.lastErrorMessageAt) {
        this.dialogData.lastErrorMessageAt = this.formattedDate(
          this.dialogData.lastErrorMessageAt.date,
        );
      }
      if (this.dialogData.lastSuccessMessageAt) {
        this.dialogData.lastSuccessMessageAt = this.formattedDate(
          this.dialogData.lastSuccessMessageAt.date,
        );
      }
      this.dialog = true;
    },
    events(id) {
      this.$router.push({
        name: 'system-kafka-import-monitor-events',
        params: { id },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.connection-cards {
  display: flex;
  flex-wrap: wrap;
  margin: 0 -10px;
  .card-item {
    width: 100%;
    max-width: calc(33.3% - 20px);
    padding: 20px;
    margin: 0 10px 50px 10px;
    border: 1px solid rgba(0, 0, 0, 0.12);
    border-radius: 5px;
    background: #fff;
    box-shadow: 0 2px 15px rgba(0, 0, 0, 0.12);
    .job-name {
      display: flex;
      justify-content: center;
      align-items: center;
      font-size: 16px;
      font-weight: 500;
      text-align: center;
      overflow: hidden;
      .job-status {
        display: block;
        width: 6px;
        height: 6px;
        border-radius: 6px;
        margin-left: 10px;
        &.worked {
          background: #62cf4e;
        }
        &.not-worked {
          background: #FC2525;
        }
      }
    }
    .chart-container {
      position: relative;
      height: 150px;
      margin: 20px 0;
    }
    .started-at, .finished-at, .last-message-at {
      font-size: 14px;
    }
    .buttons {
      display: flex;
      justify-content: space-between;
      margin-top: 20px;
    }
  }
}
</style>
